module.exports = __webpack_public_path__ + "static/img/小雪转中雪.f2763301.svg";